import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { first, map } from 'rxjs/operators';
import * as firebase from 'firebase';
import { BehaviorSubject, Subscription } from 'rxjs';
import { convertSnaps } from '../db-utils';
import { LogglyLoggerService } from '../loggly-logger/loggly-logger.service';

@Injectable({
  providedIn: 'root'
})
export class PickDropService {
  
  getUserOrdersSub: Subscription;
  userOrdersSub = new BehaviorSubject([]);
  userOrders = [];

  constructor(private afs: AngularFirestore, private logglyService: LogglyLoggerService) { }

  async getPickDropSettings(){
    try {
      const settings = await this.afs.collection('features').doc('pickDrop').valueChanges().pipe(first()).toPromise();
      return settings;
    } catch (error) {
      console.log(error);
    }
  }

  async getDeliveryCost(obj, settings){
    const object = {
      obj: obj,
      settings: settings
    };
    console.log('obj:', object);
    return new Promise(async (resolve, reject) => {
      try {
        let deliveryCost = firebase.functions().httpsCallable('pickDrop-getPickDropCost');
        deliveryCost(object).then((res) => {
              resolve(res.data);
          });
      } catch (error) {
        console.log(error)
      }
    });
  }

  async createOrder(orderDetails) {
    return new Promise(async (resolve) => {
        try {
            console.log('details:', orderDetails);
            await this.afs.collection('features').doc('pickDrop').collection('orders').add(orderDetails);
            resolve(true);
        } catch (error) {
            console.log(error);
            resolve(false);
        }
    })
}
  
  async getOrders(userId){
    console.log('userId:', userId);
    return new Promise<any[]>(async (resolve) => {
      try {
        this.getUserOrdersSub = this.afs.collection('features').doc('pickDrop').collection('orders', ref => ref
        .orderBy('createdAt', 'desc')
        .where('user.id', '==', userId))
        .snapshotChanges()
        .pipe(map(snaps => convertSnaps(snaps)))
        .subscribe(orders => {
          this.userOrders = [...orders];
          this.userOrdersSub.next(this.userOrders);
          resolve(orders);
        });
      } catch (error) {
        console.log(error);
        error['location'] = 'pick-drop-service:getOrders';
        this.logglyService.log(error);
        resolve([]);
      }
      
    });
}


}
